import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { ExitProcess, ExitProcessCreate, ExitProcessFilter } from '../data/exitProcess';

export function createExitProcessService(client: AxiosInstance) {
  return createCrudService<ExitProcess, ExitProcessCreate, ExitProcessFilter>(
    client,
    '/hrm/ExitProcess',
    'id',
  );
}

export type ExitProcessService = CrudService<ExitProcess, ExitProcessCreate, ExitProcessFilter>;
